import { Button, CardMedia, Grid, Typography } from '@mui/material'
import { Box, Container, keyframes } from '@mui/system'
import React from 'react'
// import Timeline from './Timeline'
import { Formik, Form, Field } from "formik";
import { TextField as MuiTextField } from 'formik-mui';
import * as Yup from 'yup';
import { alertMsg } from '../../utils/basicUtils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BRAND_NAME } from '../../constants';
import useAxios from '../../hooks/use-axios';
import { useTheme } from '@emotion/react'
const pageload = keyframes`
	from {
		opacity: 0;
		transform: translateX(-100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`

const ForgotPassword = () => {
    const theme = useTheme()
    const location = useLocation()
    const navigate = useNavigate();
    const axios = useAxios()
    return (
        <Box sx={{ height: { xs: "100%", md: '100vh' } }} >
            <Grid container>
                <Grid item xs={12} md={5} xl={6} >
                    <Container maxWidth="sm" sx={{ mt: 5 }}>
                        <Link to="https://primeophoto.com" style={{ textDecoration: "none" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                <Box >

                                    <CardMedia component="img" title="" sx={{ maxWidth: { xs: "60px", sm: "80px" } }} image={process.env.PUBLIC_URL + "/assets/logo.png"} />

                                </Box>
                                <Box sx={{ marginLeft: "10px", overflow: "hidden", }}>
                                    <Typography fontWeight={400} fontSize={{ xs: 28, sm: 35 }} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{BRAND_NAME}</Typography>
                                </Box>
                            </Box>
                        </Link>
                        <Box sx={{ mt: { xs: 10, sm: 8, xl: 20 } }}>
                            <Box sx={{ mt: 4, width: { xs: "100%", sm: "90%", }, marginLeft: "auto", marginRight: "auto" }}>

                                <>
                                    <Box textAlign={"center"}>
                                        <Typography fontWeight={400} sx={{ fontSize: { xs: "22px", md: "26px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Reset your account</Typography>
                                    </Box>
                                    <Formik
                                        initialValues={{
                                            email: location.state,
                                        }}
                                        validationSchema={
                                            Yup.object({
                                                email: Yup.string()
                                                    .required('Email is required'),

                                            })
                                        }
                                        onSubmit={async (values, { setSubmitting }) => {
                                            try {
                                                const response = await axios.post("accounts/forget_password/", { email: values.email })
                                                alertMsg(response.data.message, 'success')
                                            }
                                            catch (error) {
                                                console.error(error)
                                            }
                                            setSubmitting(false);
                                        }}
                                    >
                                        {
                                            ({ isSubmitting, submitForm }) => {
                                                return (
                                                    <Form>
                                                        <Box>
                                                            <Box sx={{ mt: 4, }}>
                                                                <Field
                                                                    component={MuiTextField}
                                                                    name="email"
                                                                    label="Email"
                                                                    fullWidth
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ mt: 3, textAlign: "center" }}>
                                                            <Button
                                                                size='large'
                                                                variant="outlined"
                                                                disabled={isSubmitting}
                                                                onClick={(e) => e.detail === 1 && submitForm()}
                                                            > Send Reset Link</Button>
                                                        </Box>
                                                    </Form>
                                                )
                                            }
                                        }
                                    </Formik>
                                    <Box sx={{ my: 3, textAlign: "center" }}>
                                        <Typography sx={{ marginRight: "10px" }} fontSize={15} variant='caption'>Already have an account ?</Typography>
                                        <Typography fontSize={15} color={"primary"} variant='a' onClick={() => navigate('/accounts/signin')} sx={{ cursor: "pointer" }}>sign in</Typography>
                                    </Box>
                                </>
                            </Box>
                        </Box>
                    </Container>
                </Grid>
                <Grid item md={7} xl={6} sx={{ minHeight: "100vh", display: { xs: "none", md: "flex", alignItems: "center" } }} bgcolor="primary.main">
                    <Box sx={{ width: "100%" }} >
                        <Box sx={{ padding: { xs: "16px", lg: "32px", } }}>
                            <Box sx={{ marginBottom: 4, pl: { xs: "36px", lg: "56px", } }}>
                                <Typography color={"primary.contrastText"} fontWeight={400} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, fontSize: { xs: "26px", md: "30px", xl: "36px", } }}>Simple steps</Typography>
                                <Typography color={"primary.contrastText"} fontWeight={400} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, fontSize: { xs: "26px", md: "30px", xl: "36px", } }}>Get your job done.</Typography>
                            </Box>
                            <Box sx={{ width: "85%", height: { xs: "auto", md: "300px", xl: "500px", }, borderRadius: "10px", overflow: "hidden", marginLeft: "auto", marginRight: "auto" }}>
                                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/q3B85yvWR7c?autoplay=1&mute=1&loop=1&playlist=q3B85yvWR7c&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                {/* <video width="100%" height="100%" src="https://www.youtube.com/embed/eIxwWci5Knk?autoplay=1&mute=1&loop=1&playlist=eIxwWci5Knk&controls=0"></video> */}
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    )
}

export default ForgotPassword
